export enum ApplicationActionTypes {
    INITIALIZE = '@@application/INITIALIZE'
}
